export default {
  baseStyle: {
    fontSize: 'sm',
    lineHeight: 'taller',
    fontWeight: 'regular',
    color: 'black',
    margin: '0px',
  },
}
